import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

import { ToDos } from 'src/providers/to-dos/to-dos';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';

import { roomTypeSelect } from 'src/shared/constants/roomTypeSelect';

@Component({
    templateUrl: 'add-room.html',
    standalone: false
})

export class ToDosAddRoomPage implements OnInit {

  errorMessage: string;
  form: UntypedFormGroup;
  list: any;
  loaded: boolean;
  isRightSideContent: boolean;
  rooms = roomTypeSelect;
  submitted: boolean;
  boundAddRoom = this.addRoom.bind(this);

constructor(
    private fb: UntypedFormBuilder,
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    private toDos: ToDos
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
    });
  }

  async ngOnInit() {
    this.loaded = false;
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    const dialogParams = await this.storage.retrieve('dialog-params');
    this.rightSidePanelService.setDialogPageTitle('Add Card');
    this.list = this.navCtrl.getParam('list') || dialogParams.list;
    this.loaded = true;
  }

  async addRoom() {
    try {
      this.submitted = true;
      if (!this.form.valid) {
        return;
      }
      const postPayload = {
        name: this.form.value.name
      }
      const group = await this.toDos.addGroup(postPayload);
      const payload = {
        id: group.id,
        address_task_list_id: this.list.id
      }
      await this.toDos.updateGroup(group.id, payload);
      await this.storage.save('shouldReloadPageAfterClosingSideRail', true);
      this.rightSidePanelService.navigateTo('to-dos');
    } catch(err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

}
